import { format } from 'date-fns';
import React from 'react';
import { gql } from '@urql/core';
import { HighSchoolSendsMessageFragment } from '../../../../generated/spin-graphql';

type Props = {
    message: HighSchoolSendsMessageFragment;
};

gql`
    fragment HighSchoolSendsMessage on espin_message {
        contents
        created_at
        high_school {
            name
        }
    }
`;

export const HighSchoolSendsMessage: React.FC<Props> = ({ message }) => {
    const author = message.high_school?.name ?? 'A High School';
    return (
        <div className="message-container">
            <div className="bubble">{message.contents}</div>
            <div className="message-stamp">
                <span className="author">{author}</span>
                {author && <>{'-'}</>}
                <span className="timestamp">{format(new Date(message.created_at), 'MMM d, y, h:mm a')}</span>
            </div>
        </div>
    );
};
